<!-- Main Left Sidebar -->
<div class="sidebar-container">
  <div class="main-sidebar" (mouseenter)="openSubSidebar()">
    <div class="sidebar-top">
      <div class="company-logo curser-pointer" (click)="navigateTo('/')">
        <img src="assets/images/icons/logo.png" width="28" height="28" alt="Company Logo">
      </div>

      <div class="sidebar-nav">
        <!--Home Icon-->
        <button  *ngIf="permissionService.hasMenu('todos')" class="nav-item" [class.active]="isRouteActive('todos') || isRouteActive('workbench')" (click)="navigateTo('/todos')" ngbTooltip="Home"  placement="end"  container="body" triggers="mouseenter:mouseleave">
          <svg width="17" height="17" viewBox="0 0 24 24" fill="none">
            <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" stroke="#5245e4" stroke-width="2"
              stroke-linecap="round" stroke-linejoin="round" />
            <polyline points="9,22 9,12 15,12 15,22" stroke="#5245e4" stroke-width="2" stroke-linecap="round"
              stroke-linejoin="round" />
          </svg>
        </button>

        <!--All Submissions Icon-->
        <!-- <button *ngIf="showBpMenu && permissionService.hasMenu('bpAllSubmissions')" class="nav-item" [class.active]="isRouteActive('bp-all-submissions')"
          (click)="navigateTo('/bp-all-submissions')" ngbTooltip="All Submissions"  placement="end"  container="body" triggers="mouseenter:mouseleave">
          <i class="bi bi-person-lines-fill"></i>
        </button> -->

        <!--Dashboard Management (All Submissions) Icon-->
        <button *ngIf="showBpMenu && permissionService.hasMenu('dashboardManagement')" class="nav-item" [class.active]="isRouteActive('bp-all-submissions')"
          (click)="navigateTo('/bp-all-submissions')" ngbTooltip="All Submissions"  placement="end"  container="body" triggers="mouseenter:mouseleave">
          <i class="bi bi-person-lines-fill"></i>
        </button>

        <!--Plus Icon-->
        <!-- <button class="nav-item" ngbTooltip="Add New" disabled [class.active]="isRouteActive('add-new')"  placement="end"  container="body"  triggers="mouseenter:mouseleave">
          <svg width="17" height="17" viewBox="0 0 24 24" fill="none">
            <line x1="12" y1="5" x2="12" y2="19" stroke="#5245e4" stroke-width="2" stroke-linecap="round"
              stroke-linejoin="round" />
            <line x1="5" y1="12" x2="19" y2="12" stroke="#5245e4" stroke-width="2" stroke-linecap="round"
              stroke-linejoin="round" />
          </svg>
        </button> -->

        <!-- Notification Bell -->
        <!-- <button class="nav-item" ngbTooltip="Notifications" disabled [class.active]="isRouteActive('notifications')" placement="end"  container="body"  triggers="mouseenter:mouseleave">
          <svg width="17" height="17" viewBox="0 0 24 24" fill="none">
            <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" stroke="#5245e4" stroke-width="2"
              stroke-linecap="round" stroke-linejoin="round" />
            <path d="M13.73 21a2 2 0 0 1-3.46 0" stroke="#5245e4" stroke-width="2" stroke-linecap="round"
              stroke-linejoin="round" />
          </svg> -->
        <!-- Red dot -->
        <!-- <span  class="notification-dot"></span> -->
        <!-- </button> -->

      </div>
    </div>

    <div class="sidebar-bottom">
       <lib-support [isOpen]="isPanelOpen" [appId]="appId"
                [panelTitle]="'Sense Support'"></lib-support>
      <div class="profile-container">
        <!-- Profile Dropdown -->
        <div class="dropdown">

          <!-- Avatar Button -->
          <button class="btn sidebar-avatar dropdown-toggle" type="button" id="profileDropdown"
            data-bs-toggle="dropdown" aria-expanded="false">

            {{ (firstName && firstName[0]) ? (firstName[0] | uppercase) : 'U' }}
          </button>

          <!-- Dropdown Menu -->
          <ul class="dropdown-menu dropdown-menu-end profile-dropdown shadow py-1 px-2" aria-labelledby="profileDropdown">

            <li class="p-2">
              <div class="d-flex justify-content-between align-items-center">
                <div class="d-flex gap-2 align-items-center">

                  <div class="profile-avatar-large">
                    {{ (firstName && firstName[0]) ? (firstName[0] | uppercase) : 'U' }}
                  </div>

                  <div class="profile-info">
                    <div class="fw-semibold">{{ firstName || 'User' }}</div>
                  </div>
                </div>

                <button class="logout-button" (click)="logout()">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" stroke="currentColor" stroke-width="2"
                      stroke-linecap="round" stroke-linejoin="round" />
                    <polyline points="16,17 21,12 16,7" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                      stroke-linejoin="round" />
                    <line x1="21" y1="12" x2="9" y2="12" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                      stroke-linejoin="round" />
                  </svg>
                </button>
              </div>

            </li>
          </ul>
        </div>

      </div>
    </div>
  </div>
</div>


<!-- Notification Panel -->
<!--
<div class="notification-panel-container" *ngIf="showNotificationPanel" [class.open]="showNotificationPanel">
  <app-email-notification (closePanel)="closeNotificationPanel()"></app-email-notification>
</div> -->
